<template>
    <BentoGrid class="base-cta">
        <div data-span-4 class="base-cta__left">
            <slot name="title">
                <h2 class="base-cta__title">{{ title }}</h2>
            </slot>
            <slot name="subtitle">
                <p class="base-cta__subtitle">{{ subtitle }}</p>
            </slot>
            <slot name="cta" />
        </div>
        <div v-if="$slots.default" data-span-4 class="base-cta__right">
            <slot />
        </div>
    </BentoGrid>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: 'Title'
    },
    subtitle: {
        type: String,
        default: 'SubTitle'
    }
});
</script>

<style lang="less" scoped>
.bento-grid.base-cta {
    grid-gap: var(--spacing-md);
    padding-left: 0;
    padding-right: 0;
}

.base-cta__title {
    .typography-h1();
}

.base-cta__subtitle {
    .typography-h6();
}

.base-cta__title + .base-cta__subtitle {
    margin-top: var(--spacing-md);
}

.base-cta__left {
    max-width: 30.625rem;
}

.base-cta__right {
    margin-top: var(--spacing-xs);
}

.bento-grid.base-cta.base-cta--block{
    grid-template-columns: none;
    background: var(--color-dark-green);
    padding: 20px 10px;
    border-radius: 0.625rem;
}
</style>
